import React from "react";

import { Tabs, TabsProps, useTheme } from "@mui/material";

export type IgTabsProps = TabsProps & {
  underline?: boolean;
};

export const IgTabs = (props: IgTabsProps) => {
  const { children, sx, underline, ...rest } = props;
  const theme = useTheme();
  return (
    <Tabs
      sx={{
        ...(underline && {
          borderBottom: `1px solid ${theme.igBorders.core.default} !important`,
        }),
        ...sx,
      }}
      centered={false}
      {...rest}
    >
      {children}
    </Tabs>
  );
};
